// extracted by mini-css-extract-plugin
module.exports = {"description_and_form_section_wrapper":"template_description_and_form_section_wrapper__AHdGi"};